//Imports

//Pages
import Home from './Homepage/Home';
import PhoneticsChart from "./PhoneticsChart/PhoneticsChart";

//Navigation Pages
import VowelsNav from "./DeckNavs/Phonetics/VowelsNav";
import ConsonantsNav from "./DeckNavs/Phonetics/ConsonantsNav";
import BasicWordsNav from './DeckNavs/BasicWords/BasicWordsNav';
import ConsonantVowelPairsNav from './DeckNavs/Phonetics/ConsonantVowelPairs/ConsonantVowelPairsNav';
import ColorsNav from './DeckNavs/BasicWords/ColorsNav';
import NumbersNav from './DeckNavs/BasicWords/NumbersNav';
import TimeNav from './DeckNavs/BasicWords/TimeNav';
import PronounsNav from './DeckNavs/BasicWords/PronounsNav';
import EmotionsNav from './DeckNavs/BasicWords/EmotionsNav';
import FamilyNav from './DeckNavs/BasicWords/FamilyNav';
import RelationshipsNav from './DeckNavs/BasicWords/RelationshipsNav';

//Decks

    //Phonetics
        import VowelComplexDeck from "./FlashcardDecks/Phonetics/Vowels/VowelComplexDeck";
        import VowelBasicDeck from "./FlashcardDecks/Phonetics/Vowels/VowelBasicDeck"
        import ConsonantBasicDeck from "./FlashcardDecks/Phonetics/Consonants/ConsonantBasicDeck";
        import ConsonantComplexDeck from "./FlashcardDecks/Phonetics/Consonants/ConsonantComplexDeck";


          //Consonant-Vowel Decks
              import CONSONANT_VOWEL_PAIRS_K_G_DECK from './FlashcardDecks/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_kg_Deck';
              import CONSONANT_VOWEL_PAIRS_N_DECK from './FlashcardDecks/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_n_Deck';
              import CONSONANT_VOWEL_PAIRS_D_T_DECK from './FlashcardDecks/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_dt_Deck';
              import CONSONANT_VOWEL_PAIRS_R_L_DECK from './FlashcardDecks/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_rl_Deck';
              import CONSONANT_VOWEL_PAIRS_M_DECK from './FlashcardDecks/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_m_Deck';
              import CONSONANT_VOWEL_PAIRS_P_B_DECK from './FlashcardDecks/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_pb_Deck';
              import CONSONANT_VOWEL_PAIRS_S_T_DECK from './FlashcardDecks/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_st_Deck';
              import CONSONANT_VOWEL_PAIRS_SILENT_NG_DECK from './FlashcardDecks/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_silentng_Deck';
              import CONSONANT_VOWEL_PAIRS_CH_J_DECK from './FlashcardDecks/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_chj_Deck';
              import CONSONANT_VOWEL_PAIRS_CH_T_DECK from './FlashcardDecks/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_cht_Deck';
              import CONSONANT_VOWEL_PAIRS_K_DECK from './FlashcardDecks/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_k_Deck';
              import CONSONANT_VOWEL_PAIRS_T_DECK from './FlashcardDecks/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_t_Deck';
              import CONSONANT_VOWEL_PAIRS_P_DECK from './FlashcardDecks/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_p_Deck';
              import CONSONANT_VOWEL_PAIRS_H_DECK from './FlashcardDecks/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_h_Deck';
              import CONSONANT_VOWEL_PAIRS_KK_DECK from './FlashcardDecks/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_kk_Deck';
              import CONSONANT_VOWEL_PAIRS_TT_DECK from './FlashcardDecks/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_tt_Deck';
              import CONSONANT_VOWEL_PAIRS_PP_DECK from './FlashcardDecks/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_pp_Deck';
              import CONSONANT_VOWEL_PAIRS_SS_DECK from './FlashcardDecks/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_ss_Deck';
              import CONSONANT_VOWEL_PAIRS_JJ_DECK from './FlashcardDecks/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_jj_Deck';
          


          //Basic Words
            import BasicColorsDeck from './FlashcardDecks/BasicWords/Colors/BasicColorsDeck';
            import OtherColorsDeck from './FlashcardDecks/BasicWords/Colors/OtherColorsDeck';


                //Numbers
                    // Native Numbers
                        import NAT_NUM_0_10_DECK from './FlashcardDecks/BasicWords/Numbers/Nat_Num/Nat_Num_0_10_Deck';
                        import NAT_NUM_11_19_DECK from './FlashcardDecks/BasicWords/Numbers/Nat_Num/Nat_Num_11_19_Deck';
                        import NAT_NUM_20_29_DECK from './FlashcardDecks/BasicWords/Numbers/Nat_Num/Nat_Num_20_29_Deck';
                        import NAT_NUM_30_39_DECK from './FlashcardDecks/BasicWords/Numbers/Nat_Num/Nat_Num_30_39_Deck';
                        import NAT_NUM_40_49_DECK from './FlashcardDecks/BasicWords/Numbers/Nat_Num/Nat_Num_40_49_Deck';
                        import NAT_NUM_50_59_DECK from './FlashcardDecks/BasicWords/Numbers/Nat_Num/Nat_Num_50_59_Deck';
                        import NAT_NUM_60_69_DECK from './FlashcardDecks/BasicWords/Numbers/Nat_Num/Nat_Num_60_69_Deck';
                        import NAT_NUM_70_79_DECK from './FlashcardDecks/BasicWords/Numbers/Nat_Num/Nat_Num_70_79_Deck';
                        import NAT_NUM_80_89_DECK from './FlashcardDecks/BasicWords/Numbers/Nat_Num/Nat_Num_80_89_Deck';
                        import NAT_NUM_90_99_DECK from './FlashcardDecks/BasicWords/Numbers/Nat_Num/Nat_Num_90_99_Deck';
                        import NAT_NUM_100_900_DECK from './FlashcardDecks/BasicWords/Numbers/Nat_Num/Nat_Num_100_900_Deck';
                        import NAT_NUM_1000_9000_DECK from './FlashcardDecks/BasicWords/Numbers/Nat_Num/Nat_Num_1000_9000_Deck';
                        import NAT_NUM_10000_PLUS_DECK from './FlashcardDecks/BasicWords/Numbers/Nat_Num/Nat_Num_10000_plus_Deck';

                        // Sino Numbers
                        import SINO_NUM_0_10_DECK from './FlashcardDecks/BasicWords/Numbers/Sino_Num/Sino_Num_0_10_Deck';
                        import SINO_NUM_11_19_DECK from './FlashcardDecks/BasicWords/Numbers/Sino_Num/Sino_Num_11_19_Deck';
                        import SINO_NUM_20_29_DECK from './FlashcardDecks/BasicWords/Numbers/Sino_Num/Sino_Num_20_29_Deck';
                        import SINO_NUM_30_39_DECK from './FlashcardDecks/BasicWords/Numbers/Sino_Num/Sino_Num_30_39_Deck';
                        import SINO_NUM_40_49_DECK from './FlashcardDecks/BasicWords/Numbers/Sino_Num/Sino_Num_40_49_Deck';
                        import SINO_NUM_50_59_DECK from './FlashcardDecks/BasicWords/Numbers/Sino_Num/Sino_Num_50_59_Deck';
                        import SINO_NUM_60_69_DECK from './FlashcardDecks/BasicWords/Numbers/Sino_Num/Sino_Num_60_69_Deck';
                        import SINO_NUM_70_79_DECK from './FlashcardDecks/BasicWords/Numbers/Sino_Num/Sino_Num_70_79_Deck';
                        import SINO_NUM_80_89_DECK from './FlashcardDecks/BasicWords/Numbers/Sino_Num/Sino_Num_80_89_Deck';
                        import SINO_NUM_90_99_DECK from './FlashcardDecks/BasicWords/Numbers/Sino_Num/Sino_Num_90_99_Deck';
                        import SINO_NUM_100_900_DECK from './FlashcardDecks/BasicWords/Numbers/Sino_Num/Sino_Num_100_900_Deck';
                        import SINO_NUM_1000_9000_DECK from './FlashcardDecks/BasicWords/Numbers/Sino_Num/Sino_Num_1000_9000_Deck';
                        import SINO_NUM_10000_PLUS_DECK from './FlashcardDecks/BasicWords/Numbers/Sino_Num/Sino_Num_10000_plus_Deck';

              //Time
                import DaysOfTheWeekDeck from './FlashcardDecks/BasicWords/Time/DaysOfWeekDeck';
                import DurationsDeck from './FlashcardDecks/BasicWords/Time/DurationIntervalsDeck';
                import HoursMinsDeck from './FlashcardDecks/BasicWords/Time/HoursMinsDeck';
                import MinutesDeck from './FlashcardDecks/BasicWords/Time/MinutesDeck';
                import MonthsDeck from './FlashcardDecks/BasicWords/Time/MonthsDeck';
                import PartsOfTheDayDeck from './FlashcardDecks/BasicWords/Time/PartsOfDayDeck';
                import TimeWordsDeck from './FlashcardDecks/BasicWords/Time/TimeWordsDeck';
                import HoursDeck from './FlashcardDecks/BasicWords/Time/HoursDeck';

              //Emotion
                  import BasicEmotionsDeck from './FlashcardDecks/BasicWords/Emotions/BasicEmotionsDeck';
                  import NegativeEmotionsDeck from './FlashcardDecks/BasicWords/Emotions/NegativeEmotionsDeck';
                  import ComplexEmotionsDeck from './FlashcardDecks/BasicWords/Emotions/ComplexEmotionsDeck';
                  import PositiveEmotionsDeck from './FlashcardDecks/BasicWords/Emotions/PositiveEmotionsDeck';
              
              //Pronouns
                  import DemonstrativePronounsFormalDeck from './FlashcardDecks/BasicWords/Pronouns/DemonstrativePronounsFormalDeck';
                  import DemonstrativePronounsInformalDeck from './FlashcardDecks/BasicWords/Pronouns/DemonstrativePronounsInformalDeck';
                  import IndefinitePronounsFormalDeck from './FlashcardDecks/BasicWords/Pronouns/IndefinitePronounsFormalDeck';
                  import IndefinitePronounsInformalDeck from './FlashcardDecks/BasicWords/Pronouns/IndefinitePronounsInformalDeck';
                  import InterrogativePronounsFormalDeck from './FlashcardDecks/BasicWords/Pronouns/InterrogativePronounsFormalDeck';
                  import InterrogativePronounsInformalDeck from './FlashcardDecks/BasicWords/Pronouns/InterrogativePronounsInformalDeck';
                  import ObjectPronounsFormalDeck from './FlashcardDecks/BasicWords/Pronouns/ObjectPronounsFormalDeck';
                  import ObjectPronounsInformalDeck from './FlashcardDecks/BasicWords/Pronouns/ObjectPronounsInformalDeck';
                  import PossessivePronounsFormalDeck from './FlashcardDecks/BasicWords/Pronouns/PossessivePronounsFormalDeck';
                  import PossessivePronounsInformalDeck from './FlashcardDecks/BasicWords/Pronouns/PossessivePronounsInformalDeck';
                  import ReflexivePronounsFormalDeck from './FlashcardDecks/BasicWords/Pronouns/ReflexivePronounsFormalDeck';
                  import ReflexivePronounsInformalDeck from './FlashcardDecks/BasicWords/Pronouns/ReflexivePronounsInformalDeck';
                  import SubjectPronounsFormalDeck from './FlashcardDecks/BasicWords/Pronouns/SubjectPronounsFormalDeck';
                  import SubjectPronounsInformalDeck from './FlashcardDecks/BasicWords/Pronouns/SubjectPronounsInformalDeck';

                //Family
                  import MaritalFamilyDeck from './FlashcardDecks/BasicWords/Family/MaritalFamilyDeck';
                  import ExtendedFamilyDeck from './FlashcardDecks/BasicWords/Family/ExtendedFamilyDeck';
                  import ChildrenSiblingsDeck from './FlashcardDecks/BasicWords/Family/ChildrenSiblingsDeck';
                  import RespectfulTitlesDeck from './FlashcardDecks/BasicWords/Family/RespectfulTitlesDeck';

                //Relationships
                import FriendshipDeck from './FlashcardDecks/BasicWords/Relationships/FriendshipDeck';
                import RomanticRelationsDeck from './FlashcardDecks/BasicWords/Relationships/RomanticRelations';
                import SocialRelationsDeck from './FlashcardDecks/BasicWords/Relationships/SocialRelations';
                import FormalRelationsDeck from './FlashcardDecks/BasicWords/Relationships/FormalRelations';


//Dictionaries
import ColorsDictionary from './AdditionalResources/Dictionaries/BasicWords/ColorsDictionary';
import NumbersDictionary from './AdditionalResources/Dictionaries/BasicWords/NumbersDictionary';
import TimeDictionary from './AdditionalResources/Dictionaries/BasicWords/TimeDictionary';
import PronounsDictionary from './AdditionalResources/Dictionaries/BasicWords/PronounsDictionary';
import EmotionsDictionary from './AdditionalResources/Dictionaries/BasicWords/EmotionsDictionary';
import FamilyDictionary from './AdditionalResources/Dictionaries/BasicWords/FamilyDictionary';
import RelationshipsDictionary from './AdditionalResources/Dictionaries/BasicWords/RelationshipsDictionary';


//Deeper Look
import ColorsDLook from './AdditionalResources/DeeperLook/BasicWords/ColorsDLook';
import NumbersDLook from './AdditionalResources/DeeperLook/BasicWords/NumbersDLook';
import TimeDLook from './AdditionalResources/DeeperLook/BasicWords/TimeDLook'; 
import PronounsDLook from './AdditionalResources/DeeperLook/BasicWords/PronounsDLook';
import EmotionsDLook from './AdditionalResources/DeeperLook/BasicWords/EmotionsDLook';
import FamilyDLook from './AdditionalResources/DeeperLook/BasicWords/FamilyDLook';
import RelationshipsDLook from './AdditionalResources/DeeperLook/BasicWords/RelationshipsDLook';


//Games & Activities
import MatchingGameCards from './GamesActivities/MatchingGame/MatchingGame_Cards';
import ColorPop from './GamesActivities/ColorPop/ColorPop';
import LetsCook from './GamesActivities/LetsCook/LetsCook';

//React Router
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";



//Using react router to navigate between pages
//pgs only render if URL matches the path

function App() {
return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />

      {/*Phonetics Chart*/} 
         
        <Route path="/PhoneticsChart" element={<PhoneticsChart />} />
      
      {/* Navigation (Nav) Pages*/}
       
        <Route path="/VowelsNav" element={<VowelsNav/>}/>
        <Route path="/ConsonantsNav" element={<ConsonantsNav />}/>
        <Route path="/BasicWordsNav" element={<BasicWordsNav/>}/>
        <Route path="/ColorsNav" element={<ColorsNav/>}/>
        <Route path="/NumbersNav" element={<NumbersNav/>}/>
        <Route path="/FamilyNav" element={<FamilyNav/>}/>


      {/* Flashcard Decks */}
            
            {/* Phonetics */}
                <Route path="/ConsonantBasicDeck" element={<ConsonantBasicDeck/>}/>
                <Route path="/ConsonantComplexDeck" element={<ConsonantComplexDeck/>}/>
                <Route path="/VowelComplexDeck" element={<VowelComplexDeck/>}/>
                <Route path="/VowelBasicDeck" element={<VowelBasicDeck/>}/>
                <Route path="/ConsonantVowelPairsNav" element={<ConsonantVowelPairsNav/>}/>


                   {/* Consonant-Vowel Decks */}
                      <Route path="/CONSONANT_VOWEL_PAIRS_K_G_DECK" element={<CONSONANT_VOWEL_PAIRS_K_G_DECK/>}/>
                      <Route path="/CONSONANT_VOWEL_PAIRS_N_DECK" element={<CONSONANT_VOWEL_PAIRS_N_DECK/>}/>
                      <Route path="/CONSONANT_VOWEL_PAIRS_D_T_DECK" element={<CONSONANT_VOWEL_PAIRS_D_T_DECK/>}/>
                      <Route path="/CONSONANT_VOWEL_PAIRS_R_L_DECK" element={<CONSONANT_VOWEL_PAIRS_R_L_DECK/>}/>
                      <Route path="/CONSONANT_VOWEL_PAIRS_M_DECK" element={<CONSONANT_VOWEL_PAIRS_M_DECK/>}/>
                      <Route path="/CONSONANT_VOWEL_PAIRS_P_B_DECK" element={<CONSONANT_VOWEL_PAIRS_P_B_DECK/>}/>
                      <Route path="/CONSONANT_VOWEL_PAIRS_S_T_DECK" element={<CONSONANT_VOWEL_PAIRS_S_T_DECK/>}/>
                      <Route path="/CONSONANT_VOWEL_PAIRS_SILENT_NG_DECK" element={<CONSONANT_VOWEL_PAIRS_SILENT_NG_DECK/>}/>
                      <Route path="/CONSONANT_VOWEL_PAIRS_CH_J_DECK" element={<CONSONANT_VOWEL_PAIRS_CH_J_DECK/>}/>
                      <Route path="/CONSONANT_VOWEL_PAIRS_CH_T_DECK" element={<CONSONANT_VOWEL_PAIRS_CH_T_DECK/>}/>
                      <Route path="/CONSONANT_VOWEL_PAIRS_K_DECK" element={<CONSONANT_VOWEL_PAIRS_K_DECK/>}/>
                      <Route path="/CONSONANT_VOWEL_PAIRS_T_DECK" element={<CONSONANT_VOWEL_PAIRS_T_DECK/>}/>
                      <Route path="/CONSONANT_VOWEL_PAIRS_P_DECK" element={<CONSONANT_VOWEL_PAIRS_P_DECK/>}/>
                      <Route path="/CONSONANT_VOWEL_PAIRS_H_DECK" element={<CONSONANT_VOWEL_PAIRS_H_DECK/>}/>
                      <Route path="/CONSONANT_VOWEL_PAIRS_KK_DECK" element={<CONSONANT_VOWEL_PAIRS_KK_DECK/>}/>
                      <Route path="/CONSONANT_VOWEL_PAIRS_TT_DECK" element={<CONSONANT_VOWEL_PAIRS_TT_DECK/>}/>
                      <Route path="/CONSONANT_VOWEL_PAIRS_PP_DECK" element={<CONSONANT_VOWEL_PAIRS_PP_DECK/>}/>
                      <Route path="/CONSONANT_VOWEL_PAIRS_SS_DECK" element={<CONSONANT_VOWEL_PAIRS_SS_DECK/>}/>
                      <Route path="/CONSONANT_VOWEL_PAIRS_JJ_DECK" element={<CONSONANT_VOWEL_PAIRS_JJ_DECK/>}/>
                   
                   
                   {/* Basic Words */} 
                    
                       <Route path="/BasicColorsDeck" element={<BasicColorsDeck/>}/>
                       <Route path="/OtherColorsDeck" element={<OtherColorsDeck/>}/>
                       <Route path="/PronounsNav" element={<PronounsNav/>}/>
                       <Route path="/EmotionsNav" element={<EmotionsNav/>}/>
                       <Route path="/RelationshipsNav" element={<RelationshipsNav/>}/>

                            {/* Numbers */} 

                              {/* Native Numbers */}
                                  <Route path="/Nat_Num_0_10_Deck" element={<NAT_NUM_0_10_DECK />} />
                                  <Route path="/Nat_Num_11_19_Deck" element={<NAT_NUM_11_19_DECK />} />
                                  <Route path="/Nat_Num_20_29_Deck" element={<NAT_NUM_20_29_DECK />} />
                                  <Route path="/Nat_Num_30_39_Deck" element={<NAT_NUM_30_39_DECK />} />
                                  <Route path="/Nat_Num_40_49_Deck" element={<NAT_NUM_40_49_DECK />} />
                                  <Route path="/Nat_Num_50_59_Deck" element={<NAT_NUM_50_59_DECK />} />
                                  <Route path="/Nat_Num_60_69_Deck" element={<NAT_NUM_60_69_DECK />} />
                                  <Route path="/Nat_Num_70_79_Deck" element={<NAT_NUM_70_79_DECK />} />
                                  <Route path="/Nat_Num_80_89_Deck" element={<NAT_NUM_80_89_DECK />} />
                                  <Route path="/Nat_Num_90_99_Deck" element={<NAT_NUM_90_99_DECK />} />
                                  <Route path="/Nat_Num_100_900_Deck" element={<NAT_NUM_100_900_DECK />} />
                                  <Route path="/Nat_Num_1000_9000_Deck" element={<NAT_NUM_1000_9000_DECK />} />
                                  <Route path="/Nat_Num_10000_plus_Deck" element={<NAT_NUM_10000_PLUS_DECK />} />

                                {/* Sino Numbers */}
                                  <Route path="/Sino_Num_0_10_Deck" element={<SINO_NUM_0_10_DECK />} />
                                  <Route path="/Sino_Num_11_19_Deck" element={<SINO_NUM_11_19_DECK />} />
                                  <Route path="/Sino_Num_20_29_Deck" element={<SINO_NUM_20_29_DECK />} />
                                  <Route path="/Sino_Num_30_39_Deck" element={<SINO_NUM_30_39_DECK />} />
                                  <Route path="/Sino_Num_40_49_Deck" element={<SINO_NUM_40_49_DECK />} />
                                  <Route path="/Sino_Num_50_59_Deck" element={<SINO_NUM_50_59_DECK />} />
                                  <Route path="/Sino_Num_60_69_Deck" element={<SINO_NUM_60_69_DECK />} />
                                  <Route path="/Sino_Num_70_79_Deck" element={<SINO_NUM_70_79_DECK />} />
                                  <Route path="/Sino_Num_80_89_Deck" element={<SINO_NUM_80_89_DECK />} />
                                  <Route path="/Sino_Num_90_99_Deck" element={<SINO_NUM_90_99_DECK />} />
                                  <Route path="/Sino_Num_100_900_Deck" element={<SINO_NUM_100_900_DECK />} />
                                  <Route path="/Sino_Num_1000_9000_Deck" element={<SINO_NUM_1000_9000_DECK />} />
                                  <Route path="/Sino_Num_10000_plus_Deck" element={<SINO_NUM_10000_PLUS_DECK />} />
                            
                            {/*Time*/}
                             <Route path="/TimeNav" element={<TimeNav/>}/>
                             <Route path="/DaysOfTheWeekDeck" element={<DaysOfTheWeekDeck />} />
                             <Route path="/DurationsDeck" element={<DurationsDeck />} />
                             <Route path="/HoursMinsDeck" element={<HoursMinsDeck />} />
                             <Route path="/HoursDeck" element={<HoursDeck />} />
                             <Route path="/MinutesDeck" element={<MinutesDeck />} />
                             <Route path="/MonthsDeck" element={<MonthsDeck />} />
                             <Route path="/PartsOfTheDayDeck" element={<PartsOfTheDayDeck />} />
                             <Route path="/TimeWordsDeck" element={<TimeWordsDeck />} />

                            {/*Emotions*/}
                             <Route path="/BasicEmotionsDeck" element={<BasicEmotionsDeck/>}/>
                             <Route path="/ComplexEmotionsDeck" element={<ComplexEmotionsDeck />} />
                             <Route path="/PositiveEmotionsDeck" element={<PositiveEmotionsDeck />} />
                             <Route path="/NegativeEmotionsDeck" element={<NegativeEmotionsDeck />} />

                            {/* Pronouns */}
                             <Route path="/DemonstrativePronounsInformalDeck" element={<DemonstrativePronounsInformalDeck/>}/>
                             <Route path="/DemonstrativePronounsFormalDeck" element={<DemonstrativePronounsFormalDeck />} />
                             <Route path="/IndefinitePronounsFormalDeck" element={<IndefinitePronounsFormalDeck />} />
                             <Route path="/IndefinitePronounsInformalDeck" element={<IndefinitePronounsInformalDeck />} />
                             <Route path="/InterrogativePronounsFormalDeck" element={<InterrogativePronounsFormalDeck/>}/>
                             <Route path="/InterrogativePronounsInformalDeck" element={<InterrogativePronounsInformalDeck />} />
                             <Route path="/ObjectPronounsFormalDeck" element={<ObjectPronounsFormalDeck />} />
                             <Route path="/ObjectPronounsInformalDeck" element={<ObjectPronounsInformalDeck />} />
                             <Route path="/PossessivePronounsFormalDeck" element={<PossessivePronounsFormalDeck/>}/>
                             <Route path="/PossessivePronounsInformalDeck" element={<PossessivePronounsInformalDeck />} />
                             <Route path="/ReflexivePronounsFormalDeck" element={<ReflexivePronounsFormalDeck />} />
                             <Route path="/ReflexivePronounsInformalDeck" element={<ReflexivePronounsInformalDeck />} />
                             <Route path="/SubjectPronounsFormalDeck" element={<SubjectPronounsFormalDeck />} />
                             <Route path="/SubjectPronounsInformalDeck" element={<SubjectPronounsInformalDeck />} />


                            {/* Family */}
                              <Route path="/RespectfulTitlesDeck" element={<RespectfulTitlesDeck/>}/>
                              <Route path="/MaritalFamilyDeck" element={<MaritalFamilyDeck />} />
                              <Route path="/ExtendedFamilyDeck" element={<ExtendedFamilyDeck />} />
                              <Route path="/ChildrenSiblingsDeck" element={<ChildrenSiblingsDeck />} />
          
                            {/* Relationships */}
                              <Route path="/FriendshipDeck" element={<FriendshipDeck />} />
                              <Route path="/RomanticRelationsDeck" element={<RomanticRelationsDeck />} />
                              <Route path="/SocialRelationsDeck" element={<SocialRelationsDeck />} />
                              <Route path="/FormalRelationsDeck" element={<FormalRelationsDeck />} />


         {/* Dictionaries */}
            
            <Route path="/NumbersDictionary" element={<NumbersDictionary/>}/>
            <Route path="/ColorsDictionary" element={<ColorsDictionary/>}/>
            <Route path="/TimeDictionary" element={<TimeDictionary/>}/>
            <Route path="/PronounsDictionary" element={<PronounsDictionary/>}/>
            <Route path="/EmotionsDictionary" element={<EmotionsDictionary/>}/>
            <Route path="/FamilyDictionary" element={<FamilyDictionary/>}/>
            <Route path="/RelationshipsDictionary" element={<RelationshipsDictionary/>}/>



         {/* Deeper Look */}

            <Route path="/ColorsDLook" element={<ColorsDLook/>}/>
            <Route path="/NumbersDLook" element={<NumbersDLook/>}/>
            <Route path="/TimeDLook" element={<TimeDLook/>}/>
            <Route path="/PronounsDLook" element={<PronounsDLook/>}/>
            <Route path="/EmotionsDLook" element={<EmotionsDLook/>}/>
            <Route path="/FamilyDLook" element={<FamilyDLook/>}/>
            <Route path="/RelationshipsDLook" element={<RelationshipsDLook/>}/>


        {/* Games & Activities */}
            
            <Route path="/MatchingGameCards" element={<MatchingGameCards/>}/>
            <Route path="/ColorPop" element={<ColorPop/>}/>
            <Route path="/LetsCook" element={<LetsCook/>}/>

        {/* Testing */}
      
      
      </Routes>
    </Router>
  );
}

export default App;